window.RVA_FAB={13538:["cotton","100% cotton"],957777:["cotton","100% organic cotton"],957774:["cotton","100% organic cotton"],981674:["cotton","100% organic cotton"],981673:["cotton","100% organic cotton"],8168:["cotton","100% cotton"],11733:["cotton","100% cotton"],8169:["cotton","100% cotton"],6364:["cotton","100% cotton"],6397:["cotton","100% cotton"],6388:["triblend","tri-blend"],387:["blend","80/20 blend"],173:["5050","50/50 blend"],83:["cotton","100% cotton"],88:["cotton","100% cotton"],7833:["blend","80/20 blend"],3868:["cotton","100% cotton"],3855:["5050","50/50 blend"],29:["cotton","100% cotton"],7584:["blend","52/48 blend"],24:["cotton","100% cotton"],2211:["cotton","100% cotton"],2764:["blend","52/48 blend"],8291:["blend","52/48 blend"],1441:["triblend","tri-blend"],2212:["triblend","tri-blend"],123:["cotton","100% cotton"],1787:["cotton","100% cotton"],2213:["blend","52/48 blend"],2768:["blend","52/48 blend"],6174:["blend","52/48 blend"],2769:["blend","52/48 blend"],2003:["blend","52/48 blend"],1754:["cotton","100% cotton"],1761:["blend","82/18 blend"],1760:["blend","82/18 blend"],1758:["5050","50/50 blend"],1757:["5050","50/50 blend"],1756:["5050","50/50 blend"],8803:["cotton","100% cotton"],10928:["cotton","100% cotton"],10931:["5050","50/50 blend"],12350:["cotton","100% cotton"],16291:["cotton","100% cotton"],16196:["cotton","100% cotton"],10935:["cotton","100% cotton"],11675:["cotton","100% cotton"],11676:["cotton","100% cotton"],9357:["blend","80/20 blend"],1610:["blend","80/20 blend"],3946:["blend","80/20 blend"],4735:["blend","80/20 blend"],1822:["cotton","100% cotton"],9356:["cotton","100% cotton"],3444:["cotton","100% cotton"],2217:["cotton","100% cotton"],1963:["cotton","100% cotton"],17094:["cotton","100% cotton"],6255:["cotton","100% cotton"],6256:["cotton","100% cotton"],6257:["cotton","100% cotton"],6258:["cotton","100% cotton"],6260:["blend","80/20 blend"],6262:["blend","80/20 blend"],13449:["cotton","100% cotton"],13644:["cotton","100% cotton"],13552:["cotton","100% cotton"],13555:["cotton","100% cotton"],13589:["blend","60/40 blend"],375:["5050","50/50 blend"],423:["5050","50/50 blend"],372:["5050","50/50 blend"],395:["5050","50/50 blend"],415:["5050","50/50 blend"],39:["cotton","100% cotton"],155:["cotton","100% cotton"],135:["cotton","100% cotton"],117:["cotton","100% cotton"],2691:["poly","100% polyester"],2694:["poly","100% polyester"],16:["cotton","100% cotton"],4467:["cotton","100% cotton"],94:["cotton","100% cotton"],3900:["cotton","100% cotton"],32:["cotton","100% cotton"],1941:["cotton","100% cotton"],2116:["cotton","100% cotton"],146:["5050","50/50 blend"],160:["5050","50/50 blend"],4435:["triblend","tri-blend"],2561:["poly","100% polyester"],4441:["poly","100% polyester"],28:["cotton","100% cotton"],143:["5050","50/50 blend"],55:["cotton","100% cotton"],184:["cotton","100% cotton"],182:["cotton","100% cotton"],33:["cotton","100% cotton"],10:["cotton","100% cotton"],90:["cotton","100% cotton"],130:["cotton","100% cotton"],6533:["blend","80/20 blend"],1616:["blend","80/20 blend"],4232:["blend","70/30 blend"],11979:["blend","80/20 blend"],403:["blend","70/30 blend"],360:["blend","70/30 blend"],2387:["blend","55/45 blend"],3303:["blend","52/48 blend"],3304:["blend","52/48 blend"],3800:["blend","52/48 blend"],6717:["blend","80/20 blend"],6015:["blend","80/20 blend"],2771:["blend","80/20 blend"],1828:["blend","80/20 blend"],1829:["blend","80/20 blend"],2715:["poly","100% polyester"],166:["5050","50/50 blend"],422:["5050","50/50 blend"],393:["5050","50/50 blend"],16071:["blend","52/48 blend"],16074:["blend","52/48 blend"],13543:["blend","80/20 blend"],13544:["blend","80/20 blend"],13530:["blend","80/20 blend"],13545:["blend","80/20 blend"],13532:["blend","80/20 blend"],17131:["blend","80/20 blend"],13534:["cotton","100% cotton"],13531:["cotton","100% cotton"],12392:["cotton","100% cotton"],2564:["cotton","100% cotton"],12394:["blend","60/40 blend"],9121:["blend","55/45 blend"],6943:["cotton","100% cotton"],2566:["blend","60/40 blend"],6946:["blend","60/40 blend"],3422:["blend","60/40 blend"],16990:["cotton","100% cotton"],9440:["cotton","100% cotton"],9460:["cotton","100% cotton"],9529:["cotton","100% cotton"],4854:["blend","60/40 blend"],3206:["cotton","100% cotton"],3214:["cotton","100% cotton"],3215:["cotton","100% cotton"],6312:["cotton","100% cotton"],3221:["triblend","tri-blend"],3896:["triblend","tri-blend"],4161:["triblend","tri-blend"],3226:["blend","65/35 blend"],3227:["blend","60/40 blend"],3228:["blend","60/40 blend"],3497:["blend","60/40 blend"],6796:["blend","80/20 blend"],12377:["5050","50/50 blend"],12378:["5050","50/50 blend"],12387:["5050","50/50 blend"],14760:["cotton","100% cotton"],14723:["cotton","100% cotton"],14796:["cotton","100% cotton"],16306:["cotton","100% cotton"],14740:["cotton","100% cotton"],13985:["blend","60/40 blend"],14005:["blend","60/40 blend"],13996:["triblend","tri-blend"],10667:["cotton","100% cotton"],12346:["cotton","100% cotton"],10680:["blend","65/35 blend"],10706:["blend","65/35 blend"],10672:["blend","65/35 blend"],10705:["cotton","100% cotton"],11304:["cotton","100% cotton"]};

(function () {
  var DROP = { 'shaka wear': 1, 'threadfast apparel': 1, 'econscious': 1, 'us blanks': 1 };
  function keep(st) { return !(st && DROP[String(st.b || '').toLowerCase()]); }
  var S = window.STYLES = window.STYLES || [];
  for (var i = S.length - 1; i >= 0; i--) if (!keep(S[i])) S.splice(i, 1);
  if (!S.__rvaTrim) {
    var push = S.push;
    S.push = function () { return push.apply(this, Array.prototype.filter.call(arguments, keep)); };
    S.__rvaTrim = 1;
  }
})();

(function () {
  var WHITE = /^(white|natural|pfd white|prepared for dye|ivory)$/i, BLACK = /^(black|jet black|true black|solid black)$/i;
  function price(st, c) { return c.length > 4 && c[4] != null ? +c[4] : st.blank; }
  function regular(st) {
    var i, m = {}, best = null;
    for (i = 0; i < st.c.length; i++) if (BLACK.test(String(st.c[i][0]).trim())) return price(st, st.c[i]);
    for (i = 0; i < st.c.length; i++) {
      if (WHITE.test(String(st.c[i][0]).trim())) continue;
      var p = price(st, st.c[i]); m[p] = (m[p] || 0) + 1;
      if (best === null || m[p] > m[best]) best = p;
    }
    return best === null ? st.blank : +best;
  }
  function clean(st) {
    if (!st || !st.c || !st.c.length || st.__rvaClean) return st;
    st.__rvaClean = 1;
    var reg = regular(st), low = reg * 0.85;
    var cut = st.c.filter(function (c) { return !WHITE.test(String(c[0]).trim()) && price(st, c) < low; });
    var cutP = {}; cut.forEach(function (c) { cutP[price(st, c)] = 1; });
    st.c = st.c.filter(function (c) {
      var p = price(st, c);
      if (p >= low) return true;
      return WHITE.test(String(c[0]).trim()) && !cutP[p];
    });
    if (st.blank < low) st.blank = reg;
    st.__thin = st.c.length < 4;
    return st;
  }
  var S = window.STYLES = window.STYLES || [];
  for (var i = S.length - 1; i >= 0; i--) { clean(S[i]); if (S[i] && S[i].__thin) S.splice(i, 1); }
  if (!S.__rvaClear) {
    var push = S.push;
    S.push = function () {
      return push.apply(this, Array.prototype.filter.call(arguments, function (st) { clean(st); return !(st && st.__thin); }));
    };
    S.__rvaClear = 1;
  }
})();
(function () {
  var WT = { 6388: '4 oz', 2387: '7 oz', 6946: '4.5 oz', 3206: '4.3 oz', 3214: '4.3 oz', 12346: '4.5 oz' };
  (window.STYLES || []).forEach(function (st) {
    var w = st && WT[st.sid];
    if (w && typeof st.spec === 'string') st.spec = w + ', ' + st.spec.replace(/^[\d.]+\s*oz\b,?\s*/i, '');
  });
})();
(function () {
  var CDN = 'https://cdnp.sanmar.com/medias/sys_master/images/';
  function style(o, pid, rows) {
    o.sz = ['S', 'M', 'L', 'XL', '2XL', '3XL'];
    o.c = rows.map(function (r) {
      var f = '1200W_' + pid + '_' + r[3] + '-0-' + o.s + r[3] + 'ModelFront' + (r[4] || '');
      return [r[0], r[1], 0, CDN + r[2] + '/' + f + '/' + f.replace(/_/g, '-') + '.jpg'];
    });
    return o;
  }
  (window.STYLES = window.STYLES || []).push(
    style({ b: 'Stanley/Stella', n: "Unisex Crafter Tee", s: "SXU007", t: 'tee', blank: 5.24, up: [0, 2], spec: "4.6 oz, 100% organic cotton", sid: 957774 }, "57774", [
      ["Anthracite","#4d4f4c","h41/h64/32119745216542","Anthracite","2"],
      ["Black","#16161a","h50/h2d/32127350013982","Black","2"],
      ["Blue Ice","#d1ecf7","hff/ha6/28488096743454","BlueIce","1"],
      ["Bottle Green","#344f3e","hfd/hba/32127352635422","BottleGrn","2"],
      ["Bright Blue","#5971a1","h78/h1e/28488099692574","BrtBlue","1"],
      ["Burgundy","#5f2533","h0a/h15/32127355256862","Burgundy","2"],
      ["Butter","#f9e3aa","h56/hd3/28488102510622","Butter","1"],
      ["Canyon Pink","#d09994","hd3/hdd/28488102838302","CanyonPink","1"],
      ["Caribbean Blue","#cff1e1","hef/h5c/28490266247198","CariBlue","1"],
      ["Cotton Pink","#edcace","h40/hc5/28490268540958","CottonPink","1"],
      ["Dark Heather Grey","#393a3c","h42/hd3/32127357878302","DkHtGry","2"],
      ["Desert Dust","#c4b8a0","h71/hbb/28490268803102","DesertDust","1"],
      ["Eco Heather","#e0d5cf","h24/hd3/28490271752222","EcoHeather","1"],
      ["Fiesta","#fd6a5b","h5d/h70/28490272538654","Fiesta","1"],
      ["French Navy","#172737","h11/hb4/32127360565278","FrenchNavy","2"],
      ["Heather Grey","#b9bab2","h20/h6e/28490274897950","HthrGrey","1"],
      ["India Ink Grey","#3c4447","hf6/h1b/32127363186718","IndiaInkGy","2"],
      ["Khaki Green","#4c4f3c","ha6/hce/32127365808158","KhakiGreen","2"],
      ["Lavender","#bbb9cf","h01/h07/28490278436894","Lavender","1"],
      ["Natural Raw","#f7ecd0","h8a/h73/28490280599582","NaturalRaw","1"],
      ["Ocean Depth","#407364","h80/h17/28490281189406","OceanDepth","1"],
      ["Red","#b01c3c","h69/h4e/28490282041374","Red","1"],
      ["Royal Blue","#035682","hdc/hd3/28490283876382","RoyalBlue","1"],
      ["Sky Blue","#a1bcc3","h5a/hcc/28490284597278","SkyBlue","1"],
      ["Teal Monstera","#76ada7","h50/h70/28490285187102","TlMonstera","1"],
      ["Vintage White","#f3ebe8","hef/h62/28490287153182","VtgWhite","1"],
      ["White","#f8f7f4","h8d/h73/28490287611934","White","1"]]),
    style({ b: 'Stanley/Stella', n: "Unisex Sparker 2.0 Tee", s: "SXU017", t: 'tee', blank: 9.71, up: [0, 2], spec: "6.3 oz, 100% organic cotton", sid: 981674 }, "81674", [
      ["Aloe","#a8bfb3","ha4/hd4/33100502695966","Aloe"],
      ["Anthracite","#505254","h01/h72/33100505907230","Anthracite"],
      ["Black","#16161a","h0f/hba/33100507938846","Black"],
      ["Blue Ice","#e1ecee","h4f/hdf/33100510494750","BlueIce"],
      ["Bubble Pink","#e594b5","h26/h6e/33100513902622","BubblePink"],
      ["Earthy Red","#a03e38","h3c/hbd/33100515999774","EarthyRed"],
      ["Eco Heather","#f5efe7","h0d/h72/33100518555678","EcoHeather"],
      ["Fiesta","#fe6e56","hfa/h6a/33100521963550","Fiesta"],
      ["French Navy","#1e2d40","h16/hc1/33100523995166","FrenchNavy"],
      ["Glazed Green","#1a4845","h22/h6b/33100526485534","GlazedGrn"],
      ["Green Bay","#64827c","h35/h51/33100529631262","GreenBay"],
      ["Heather Grey","#b7b7b9","h86/h66/33100534415390","HthrGrey"],
      ["Heritage Brown","#af5645","he0/he0/33100531138590","HeriBrown"],
      ["Khaki Green","#53544c","h70/h66/33100537102366","KhakiGreen"],
      ["Latte","#d8ac83","hdb/h17/33100538707998","Latte"],
      ["Natural Raw","#f2e9db","h43/h5f/33100542312478","NaturalRaw"],
      ["Nispero","#fac985","h76/hcc/33100544376862","Nispero"],
      ["Off White","#f4efec","h92/h66/33100547063838","OffWhite"],
      ["Stargazer","#22525c","he4/h65/33100550635550","Stargazer"],
      ["Violet","#999dc2","he6/hcf/33100551651358","Violet"],
      ["White","#f8f7f4","hb5/h65/33100555124766","White"],
      ["Worker Blue","#17347d","h4a/hc3/33100557221918","WorkerBlue"]]),
    style({ b: 'Stanley/Stella', n: "Unisex Freestyler Vintage Heavyweight Tee", s: "SXU019", t: 'tee', blank: 12.12, up: [0, 2], spec: "7 oz, 100% organic cotton", sid: 981673 }, "81673", [
      ["G. Dyed Anthracite","#646870","hb0/h35/33100290949150","GDyedAnth"],
      ["G. Dyed Black Rock","#2c3235","h86/h93/33100293767198","GDyedBkRck"],
      ["G. Dyed Blue Stone","#a8bbc9","h8b/hfb/33100297043998","GDyedBlStn"],
      ["G. Dyed Latte","#d4ac88","hd0/h78/33100495028254","GDyedLatte"],
      ["G. Dyed Misty Grey","#99a09c","h9c/h50/33100500467742","GDyedMsGry"],
      ["G. Dyed Mocha","#78665c","h97/h49/33100498042910","GDyedMocha"]])
  );
  window.RVA_DESC = Object.assign(window.RVA_DESC || {}, {
    957774: ["4.6 oz. (155 GSM), 100% organic combed ring-spun cotton, 28 singles", "Medium fit, trim across the shoulders", "1x1 rib knit neck", "Self-fabric back neck taping", "Double-needle topstitched sleeves and hem", "100% recycled polyester tear-away label"],
    981674: ["6.3 oz. (215 GSM), 100% organic carded cotton, 16 singles", "Relaxed fit, with more ease of movement", "1x1 rib knit neck", "Self-fabric back neck taping", "Side seamed", "Double-needle topstitched sleeves and hem"],
    981673: ["7 oz. (240 GSM), 100% organic garment-dyed cotton, 16 singles", "Relaxed fit, with more ease of movement", "1x1 rib knit neck", "Self-fabric back neck taping", "Double-needle topstitched sleeves and hem", "Garment-dyed, so the shade can vary slightly from piece to piece"]
  });
})();
(function () {
  var cache = typeof WeakMap === 'function' ? new WeakMap() : null;
  function isURL(v) { return typeof v === 'string' && /^https?:\/\//.test(v); }
  function lab(hex) {
    var n = parseInt(String(hex).slice(1), 16);
    var c = [n >> 16 & 255, n >> 8 & 255, n & 255].map(function (v) {
      v /= 255;
      return v <= 0.04045 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
    });
    function f(t) { return t > 0.008856 ? Math.pow(t, 1 / 3) : 7.787 * t + 16 / 116; }
    var x = f((c[0] * 0.4124 + c[1] * 0.3576 + c[2] * 0.1805) / 0.95047);
    var y = f(c[0] * 0.2126 + c[1] * 0.7152 + c[2] * 0.0722);
    var z = f((c[0] * 0.0193 + c[1] * 0.1192 + c[2] * 0.9505) / 1.08883);
    return [116 * y - 16, 500 * (x - y), 200 * (y - z)];
  }
  function standIn(st, c) {
    if (!st || !st.alt || !st.c || !c || c[3]) return null;
    var fam = typeof window.famOf === 'function' ? window.famOf(c[1]) : null;
    var L = lab(c[1]), best = null, bd = Infinity, same = null, sd = Infinity;
    for (var i = 0; i < st.c.length; i++) {
      var o = st.c[i];
      if (!o[3]) continue;
      var q = lab(o[1]);
      var d = Math.sqrt(Math.pow(L[0] - q[0], 2) + Math.pow(L[1] - q[1], 2) + Math.pow(L[2] - q[2], 2));
      if (d < bd) { bd = d; best = o; }
      if (fam && window.famOf(o[1]) === fam && d < sd) { sd = d; same = o; }
    }
    return same || best;
  }
  function styleOf(c) {
    var S = window.S, i;
    if (S && S.req && typeof window.styleById === 'function') {
      for (i = 0; i < S.req.length; i++) if (S.req[i].color === c) return window.styleById(S.req[i].id);
    }
    var all = window.STYLES || [];
    for (i = 0; i < all.length; i++) if (all[i].c && all[i].c.indexOf(c) >= 0) return all[i];
    return null;
  }
  function altOf(c) {
    if (cache && cache.has(c)) return cache.get(c);
    var alt = standIn(styleOf(c), c);
    if (cache) cache.set(c, alt);
    return alt;
  }
  function patch() {
    if (typeof window.frontURL !== 'function') return false;
    if (window.frontURL.__rvaURL) return true;
    var fu = window.frontURL;
    var f = function (c) {
      if (c && isURL(c[3])) return c[3];
      if (c && !c[3]) {
        var alt = altOf(c);
        if (alt) return isURL(alt[3]) ? alt[3] : fu.call(this, alt);
      }
      return fu.apply(this, arguments);
    };
    f.__rvaURL = 1;
    window.frontURL = f;
    if (typeof window.setTile === 'function') {
      var tile0 = window.setTile;
      window.setTile = function (card, st, id, hex) {
        var url = isURL(id) ? id : '';
        if (!url && !+id && st && st.c) {
          var c = null, dot = null, i;
          try { dot = card && card.querySelector('.dot:hover'); } catch (e) {}
          if (dot && dot.getAttribute('data-ci') !== null) c = st.c[+dot.getAttribute('data-ci')];
          if (!c || c[3]) {
            c = null;
            for (i = 0; i < st.c.length; i++) {
              if (!st.c[i][3] && String(st.c[i][1]).toLowerCase() === String(hex).toLowerCase()) { c = st.c[i]; break; }
            }
          }
          if (c && !c[3]) url = f(c);
        }
        if (!url) return tile0.apply(this, arguments);
        var tile = card && card.querySelector('.tile');
        var cur = tile && (tile.querySelector('img.ph') || tile.querySelector('svg'));
        if (!cur) return;
        if (cur.tagName === 'IMG') { cur.src = url; cur.setAttribute('data-hex', hex); return; }
        cur.outerHTML = '<img class="ph" src="' + url + '" alt="" loading="lazy" decoding="async" data-t="' +
          st.t + '" data-hex="' + hex + '" onerror="rvaPhotoFail(this)">';
      };
    }
    try { if (typeof window.render === 'function') window.render(); } catch (e) {}
    try {
      var sh = document.getElementById('sheet');
      if (sh && !sh.hidden && window.S && window.S.open && typeof window.drawPanel === 'function') window.drawPanel();
    } catch (e) {}
    return true;
  }
  if (!patch() && document.readyState !== 'complete') document.addEventListener('DOMContentLoaded', patch);
})();

(function () {
  function std(c) { return !(c && c.length > 4 && c[4] != null); }
  function fixLeads() {
    var all = window.STYLES || [], n = 0, fam = typeof window.famOf === 'function' ? window.famOf : null;
    all.forEach(function (e) {
      if (!e || !e.c || !e.lead || std(e.lead)) return;
      var want = fam ? fam(e.lead[1]) : null, best = null, any = null, i, c;
      for (i = 0; i < e.c.length; i++) {
        c = e.c[i];
        if (!std(c) || !c[3]) continue;
        if (!any) any = c;
        if (want && fam(c[1]) === want) { best = c; break; }
      }
      if (best || any) { e.lead = best || any; n++; }
    });
    if (!n) return;
    try { if (typeof window.render === 'function') window.render(); } catch (x) {}
    try {
      var sh = document.getElementById('sheet');
      if (sh && !sh.hidden && typeof window.drawPanel === 'function') window.drawPanel();
    } catch (x) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fixLeads);
  else setTimeout(fixLeads, 0);
})();